//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const wrapQuery = query => `<span class="search-results-d__query">${query}</span>`;
const escape = query => query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    query: {
      type: String,
      default: '',
    },
    selected: {
      type: Object,
      default: () => ({}),
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      jsv: 'javascript:void(0);',
    };
  },
  methods: {
    // получить подготовленный текст строки
    getSearchCaption(caption) {
      const query = this.query;

      if (query) {
        const re = new RegExp(escape(query), 'ig');
        return caption.replace(re, wrapQuery);
      }

      return caption;
    },
    isSelected(item) {
      return item === this.selected;
    },
    getLinkClasses(item) {
      return {
        _selected: this.isSelected(item),
        _count: item.count,
      };
    },
  },
};
